





















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component
export default class ModalAutomationType extends Vue {
  @Getter networkType!: string
  selectedMode = ''
  selectedOrientation = ''

  get isPro() {
    return [
      'VIDEO_PRO',
      'ADORI_PREMIUM_MONTHLY',
      'ADORI_PREMIUM_YEARLY',
      'ADORI_BUSINESS_MONTHLY',
      'ADORI_BUSINESS_YEARLY',
    ].includes(this.networkType)
  }

  automate() {
    this.$emit('automate', {
      type: this.selectedMode,
      aiParams:
        this.selectedOrientation === 'square'
          ? {
              width: this.isPro ? '720' : '512',
              height: this.isPro ? '720' : '512',
              aspect_ratio: '1:1',
              orientation: 'squarish',
            }
          : this.selectedOrientation === 'landscape'
          ? {
              width: this.isPro ? '1280' : '896',
              height: this.isPro ? '720' : '504',
              aspect_ratio: '16:9',
              orientation: 'landscape',
            }
          : {
              width: this.isPro ? '720' : '504',
              height: this.isPro ? '1280' : '896',
              aspect_ratio: '9:16',
              orientation: 'portrait',
            },
    })
  }
}
